import PageHeader from "../components/PageHeader";
import { useLang } from "../i18n/LanguageProvider";

export default function Imprint() {
  const { t } = useLang();
  return (
    <>
      <PageHeader
        eyebrow={t("page.imprint.eyebrow")}
        title={t("page.imprint.title")}
        lede={t("page.imprint.lede")}
      />
      <section className="pb-24">
        <div className="max-w-3xl mx-auto px-6 lg:px-12 space-y-10 text-white/85 leading-relaxed">
          <div>
            <h2 className="font-serif-display text-2xl text-gold mb-3">Publisher</h2>
            <p>
              Bonworld Family Office Pte. Ltd.<br />
              111 North Bridge Road, #15-02, Peninsula Plaza<br />
              Singapore 179098
            </p>
          </div>
          <div>
            <h2 className="font-serif-display text-2xl text-gold mb-3">Contact</h2>
            <p>
              Email: <a href="mailto:office@bonworldsingapore.com" className="text-gold hover:underline">office@bonworldsingapore.com</a><br />
              By appointment only. No walk-in enquiries.
            </p>
          </div>
          <div>
            <h2 className="font-serif-display text-2xl text-gold mb-3">Registration</h2>
            <p>
              Bonworld Family Office Pte. Ltd. is incorporated in the Republic of Singapore under
              UEN <span className="text-gold">202213354N</span>, established in 2022. Bonworld is
              not a licensed deposit-taking institution; assets under advice are held with tier-one
              third-party custodians in the name of the underlying principal.
            </p>
          </div>
          <div>
            <h2 className="font-serif-display text-2xl text-gold mb-3">Responsible for content</h2>
            <p>The Board of Bonworld Family Office Pte. Ltd.</p>
          </div>
          <div>
            <h2 className="font-serif-display text-2xl text-gold mb-3">Nature of communication</h2>
            <p>
              Content published on this website is provided for general information only. It does
              not constitute an offer, solicitation or recommendation to buy or sell any security,
              product or service, nor investment, legal or tax advice. Bonworld advises solely a
              defined circle of principal families under a private engagement letter.
            </p>
          </div>
          <div>
            <h2 className="font-serif-display text-2xl text-gold mb-3">Limitation of liability</h2>
            <p>
              While every effort is made to ensure the accuracy of the information presented,
              Bonworld accepts no liability for errors, omissions or for actions taken in reliance
              on this website. External links are provided for convenience; Bonworld exercises no
              control over external content.
            </p>
          </div>
          <div>
            <h2 className="font-serif-display text-2xl text-gold mb-3">Intellectual property</h2>
            <p>
              All text, marks, imagery and design elements on this site are the property of
              Bonworld Family Office Pte. Ltd. or its licensors and are protected under applicable
              copyright and trademark law. Reproduction, in whole or in part, without written
              consent is prohibited.
            </p>
          </div>
          <div>
            <h2 className="font-serif-display text-2xl text-gold mb-3">Governing law</h2>
            <p>These notices are governed by the laws of the Republic of Singapore.</p>
          </div>
        </div>
      </section>
    </>
  );
}
